// extracted by mini-css-extract-plugin
export var avatarContainer = "_el-0";
export var gray = "_el-f";
export var green = "_el-c";
export var icon = "_el-9";
export var image = "_el-1";
export var lg = "_el-6";
export var md = "_el-5";
export var presenceDot = "_el-b";
export var red = "_el-d";
export var sm = "_el-4";
export var status = "_el-a";
export var xl = "_el-7";
export var xs = "_el-3";
export var xxl = "_el-8";
export var xxs = "_el-2";
export var yellow = "_el-e";